var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEbp3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "matrix(1 0 0 -1 0 32.5)",
    fill: "url(#paint0_linear_5700_821)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6574 25.1327C14.6192 25.1327 13.581 25.0047 12.5428 24.7487C11.5188 24.4927 10.6228 24.13 9.85477 23.6607L11.3908 20.482C11.9881 20.8802 12.6494 21.186 13.3748 21.3993C14.1143 21.6127 14.8325 21.7193 15.5294 21.7193C16.2548 21.7193 16.8308 21.5842 17.2574 21.314C17.6841 21.0438 17.8974 20.6598 17.8974 20.162C17.8974 19.7211 17.7197 19.3727 17.3641 19.1167C17.0085 18.8464 16.4254 18.7113 15.6148 18.7113H13.8441V16.0447L17.8548 11.714L18.2601 13.1646H10.6228V9.90065H21.4174V12.546L17.4068 16.8767L15.3374 15.7033H16.4894C18.3525 15.7033 19.7605 16.1229 20.7134 16.962C21.6805 17.7869 22.1641 18.8535 22.1641 20.162C22.1641 21.0153 21.9294 21.8189 21.4601 22.5727C21.005 23.3264 20.301 23.9451 19.3481 24.4287C18.3952 24.898 17.165 25.1327 15.6574 25.1327Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5700_821",
    x1: 16,
    y1: 24.6667,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2CD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#597B13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbp3);
export default __webpack_public_path__ + "static/media/ebp-3.7ab3f41ad515c49b38c57d85c10c1369.svg";
export { ForwardRef as ReactComponent };